import { render, staticRenderFns } from "./BookCentreCategories.vue?vue&type=template&id=e2603a2e&"
import script from "./BookCentreCategories.vue?vue&type=script&lang=js&"
export * from "./BookCentreCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports